import React, { useEffect, useState, Fragment } from 'react';
import { AlarmClock } from 'lucide-react';
function remaining(target: number) {
  return Math.max(0, target - Date.now());
}
export function CountdownTimer() {
  const [target, setTarget] = useState(0);
  const [time, setTime] = useState(86400000);
  useEffect(() => {
    const saved = Number(localStorage.getItem('mp_countdown_target'));
    const next = saved > Date.now() ? saved : Date.now() + 86400000;
    localStorage.setItem('mp_countdown_target', String(next));
    setTarget(next);
  }, []);
  useEffect(() => {
    if (!target) return;
    const id = window.setInterval(() => {
      const next = remaining(target);
      if (!next) {
        const reset = Date.now() + 86400000;
        localStorage.setItem('mp_countdown_target', String(reset));
        setTarget(reset);
      } else setTime(next);
    }, 1000);
    return () => clearInterval(id);
  }, [target]);
  const values = [Math.floor(time / 3600000), Math.floor(time / 60000) % 60, Math.floor(time / 1000) % 60];
  return <aside aria-label="Oferta por tiempo limitado" className="mx-auto mt-10 max-w-3xl rounded-2xl border border-[#E7D7B6] bg-white p-6 text-center shadow-[0_8px_24px_rgba(16,42,67,.07)]" data-id="element-39" data-mp="1bz3too3vnwra">
      <p className="flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wide text-navy" data-id="element-40" data-mp="12427o14wfasx">
        <AlarmClock size={19} className="text-gold" data-id="element-41" data-mp="173oiy5162gz3" />
        El precio de lanzamiento termina en:
      </p>
      <div className="my-6 flex items-center justify-center gap-2 sm:gap-4" data-id="element-42" data-mp="1utitgfy0jtg6">
        {values.map((value, i) => <Fragment key={i} data-id="element-43" data-mp="1l1mu71k6xxad" data-mpi={i}>
            <div className="min-w-[76px] rounded-xl border border-slate-200 bg-mist px-3 py-3" data-id="element-44" data-mp="1l0br73ykktkb">
              <b className="text-3xl tabular-nums text-navy sm:text-5xl" data-id="element-45" data-mp="1pzofzu904apj">
                {String(value).padStart(2, '0')}
              </b>
              <small className="ml-1 text-slate-500" data-id="element-46" data-mp="2dnxtm8w29s5l">
                {['hs', 'min', 'seg'][i]}
              </small>
            </div>
            {i < 2 && <b className="text-3xl text-gold" data-id="element-47" data-mp="2sd98uxncxr5a">:</b>}
          </Fragment>)}
      </div>
      <p className="text-xs font-bold uppercase tracking-wide text-ink" data-id="element-48" data-mp="2nd4rz6ijeuej">
        Después sube el precio y no vuelve a bajar.
      </p>
    </aside>;
}